import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Typography } from '@mui/material';

const PreviewEmailModal = ({ open, onClose, onSend, poData }) => {
  const [email, setEmail] = useState('');
  const [cc, setCc] = useState('');

  const handleSend = () => {
    onSend(email, cc);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Preview and Send Email</DialogTitle>
      <DialogContent>
        <Typography variant="h6">Purchase Order Details</Typography>
        <div>
          <Typography variant="subtitle1">Purchase Order Number: {poData.purchaseOrderNumber}</Typography>
          <Typography variant="subtitle1">Reference Number: {poData.referenceNumber}</Typography>
          <Typography variant="subtitle1">Date: {poData.date}</Typography>
          <Typography variant="subtitle1">Expected Delivery Date: {poData.expectedDeliveryDate}</Typography>
          <Typography variant="subtitle1">Payment Terms: {poData.paymentTerms}</Typography>
          <Typography variant="subtitle1">Shipment Preference: {poData.shipmentPreference}</Typography>
          <Typography variant="subtitle1">Customer Notes: {poData.customerNotes}</Typography>
          <Typography variant="subtitle1">Subtotal: {poData.subtotal}</Typography>
          <Typography variant="subtitle1">Total Quantity: {poData.totalQuantity}</Typography>
          <Typography variant="subtitle1">Discount: {poData.discount}</Typography>
          <Typography variant="subtitle1">Adjustment: {poData.adjustment}</Typography>
          <Typography variant="subtitle1">TCS: {poData.tcs}</Typography>
          <Typography variant="subtitle1">Total: {poData.total}</Typography>
        </div>
        <TextField
          label="To"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="CC"
          value={cc}
          onChange={(e) => setCc(e.target.value)}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSend} color="primary">Send</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewEmailModal;
